import React, { Component } from 'react';
import { Box } from '@mui/material';
import AboutSection from '../components/sections/AboutSection';

class AboutPage extends Component {
  render() {
    return (
      <Box>
        <AboutSection />
      </Box>
    );
  }
}

export default AboutPage;
